import styled from 'styled-components';

export const ViewMoreContainer = styled.button`
  background-color: ${({ theme }) => theme.grayF5};
  border-top: 1px solid ${({ theme }) => theme.grayCC};
  color: ${({ theme }) => theme.table.viewMoreButton.default};
  cursor: pointer;
  font-weight: 700;
  height: 43px;
  position: relative;
  width: 100%;

  &:disabled {
    color: ${({ theme }) => theme.table.viewMoreButton.disabled};
    cursor: default;
  }
`;
